import { Typography } from "@mui/material";
import { differenceInMonths, differenceInYears } from "date-fns";

const calcularDuracionObra = (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return null;

    const years = differenceInYears(fechaFin, fechaInicio);
    const months = differenceInMonths(fechaFin, fechaInicio) % 12;

    if (years < 3) return null;

    return { years, months };
};

const DuracionObraWarning = ({ fechaInicio, fechaFin }) => {
    const duracion = calcularDuracionObra(fechaInicio, fechaFin);

    if (!duracion) return null;

    return (
        <Typography color="warning.main" variant="caption" sx={{ mt: 1, display: 'block' }}>
            ⚠ Duración estimada: {duracion.years} {duracion.years === 1 ? 'año' : 'años'} y {duracion.months} {duracion.months === 1 ? 'mes' : 'meses'}
        </Typography>
    );
};

export default DuracionObraWarning;
